// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__basic_57d547', '__basic_Fallback_57d547'","fontWeight":400},"className":"__className_57d547","variable":"__variable_57d547"};